var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-container",
    { staticClass: "h-full", class: { "large-font-mode": _vm.largeFontMode } },
    [
      _c("el-main", { staticStyle: { height: "100%" } }, [
        _c(
          "div",
          { staticClass: "flex flex-row h-full" },
          [
            _c(
              "el-card",
              { staticClass: "register-con self-stretch" },
              [
                _c("patients", {
                  ref: "patients",
                  staticStyle: { width: "176px" },
                }),
              ],
              1
            ),
            _vm.activePatientInfo && Object.keys(_vm.activePatientInfo).length
              ? _c(
                  "div",
                  {
                    staticClass: "treatment-con",
                    staticStyle: {
                      display: "flex",
                      "flex-direction": "column",
                      height: "100%",
                    },
                  },
                  [
                    _c(
                      "el-card",
                      [
                        [
                          _c("div", { staticClass: "patient-header" }, [
                            _c("div", { staticClass: "header-left" }, [
                              _c("img", {
                                staticClass: "header-avatar",
                                attrs: {
                                  src: require("@/assets/treatment/profile-img.png"),
                                  alt: "头像",
                                },
                              }),
                              _c("div", { staticClass: "header-info" }, [
                                _c(
                                  "div",
                                  { staticClass: "info-row" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "patient-name" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.activePatientInfo.name || "-"
                                          )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "patient-meta" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.activePatientInfo.sexSign ===
                                              "1"
                                              ? "男"
                                              : "女"
                                          ) +
                                            "/" +
                                            _vm._s(
                                              _vm.calculateAge(
                                                _vm.activePatientInfo.birthDate
                                              )
                                            ) +
                                            "岁"
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: "info",
                                          size: "small",
                                          effect: "plain",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-question",
                                        }),
                                        _vm._v(" 未辨识 "),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "patient-phone" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.activePatientInfo
                                              .contactPhone || "-"
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm.activePatientInfo.label ||
                                _vm.activePatientInfo.patientRemark
                                  ? _c(
                                      "div",
                                      { staticClass: "tag-row" },
                                      [
                                        _vm.activePatientInfo.label
                                          ? _c(
                                              "el-tag",
                                              {
                                                attrs: {
                                                  size: "small",
                                                  type: "primary",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-s-order",
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.activePatientInfo
                                                        .label
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.activePatientInfo.patientRemark
                                          ? _c(
                                              "el-tag",
                                              {
                                                attrs: {
                                                  size: "small",
                                                  type: "info",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-edit-outline",
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.activePatientInfo
                                                        .patientRemark
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]),
                            ]),
                            _c("div", { staticClass: "header-right" }, [
                              _c(
                                "div",
                                { staticClass: "info-line info-with-action" },
                                [
                                  _c("div", { staticClass: "info-group" }, [
                                    _c(
                                      "span",
                                      { staticClass: "info-item" },
                                      [
                                        _c("label", [_vm._v("出生日期：")]),
                                        _c("value", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.activePatientInfo.birthDate ||
                                                "未知"
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c("span", { staticClass: "divider" }, [
                                      _vm._v("|"),
                                    ]),
                                    _c(
                                      "span",
                                      { staticClass: "info-item" },
                                      [
                                        _c("label", [_vm._v("就诊状态：")]),
                                        _c(
                                          "value",
                                          {
                                            class:
                                              "state-" +
                                              _vm.activeDiagRecord.diagRecord
                                                .stateSign,
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.getStateText(
                                                    _vm.activeDiagRecord
                                                      .diagRecord.stateSign
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("span", { staticClass: "divider" }, [
                                      _vm._v("|"),
                                    ]),
                                    _c(
                                      "span",
                                      { staticClass: "info-item" },
                                      [
                                        _c("label", [_vm._v("病历号：")]),
                                        _c("value", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.activeDiagRecord.diagRecord
                                                .code || "-"
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "info-line secondary-line" },
                                [
                                  _vm.activePatientInfo.contactAddress
                                    ? _c(
                                        "span",
                                        { staticClass: "info-item" },
                                        [
                                          _c("label", [_vm._v("地址：")]),
                                          _c("value", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.activePatientInfo
                                                  .contactAddress
                                              )
                                            ),
                                          ]),
                                        ],
                                        1
                                      )
                                    : _c("span", {
                                        staticClass: "placeholder",
                                      }),
                                ]
                              ),
                            ]),
                          ]),
                        ],
                      ],
                      2
                    ),
                    _c("el-card", { staticClass: "history-container" }, [
                      _c("div", { staticClass: "flex flex-row w-full" }, [
                        _c(
                          "div",
                          {
                            staticClass: "w-7/10 history-section",
                            staticStyle: { width: "100%", height: "70vh" },
                          },
                          [
                            _vm.hisTreatmentRecords.length > 0
                              ? _c("div", { staticClass: "history-content" }, [
                                  _c(
                                    "div",
                                    { staticClass: "diagnosis-record-con" },
                                    [
                                      _c(
                                        "el-timeline",
                                        { staticClass: "history-timeline" },
                                        _vm._l(
                                          _vm.hisTreatmentRecords,
                                          function (record) {
                                            return _c(
                                              "el-timeline-item",
                                              {
                                                key: record.id,
                                                attrs: { type: "primary" },
                                              },
                                              [
                                                _c("diagnosis-record", {
                                                  staticClass: "record",
                                                  attrs: { record: record },
                                                  on: {
                                                    command:
                                                      _vm.handleDiagnosisRecord,
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ])
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "no-data flex flex-col w-full align-center justify-center",
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "no-data-label" },
                                      [_vm._v("抱歉, 暂无相关数据")]
                                    ),
                                  ]
                                ),
                          ]
                        ),
                      ]),
                    ]),
                  ],
                  1
                )
              : _c(
                  "div",
                  {
                    staticClass: "no-patient-tip",
                    staticStyle: {
                      flex: "1",
                      display: "flex",
                      "align-items": "center",
                      "justify-content": "center",
                      color: "#999",
                    },
                  },
                  [_vm._v(" 请从左侧选择一位病人开始诊疗 ")]
                ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }